import styled from '@emotion/styled'

export const ToolbarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const ToolbarActions = styled.div`
  display: flex;
  align-items: center;
  gap: var(--lumen-spacing-8);
`
